console.log('js/loader.js -> v0.1.0');

var loader = (() => {
	return {
		/**
		 * @param {DOMNode} target
		 * @param {Boolean} inline
		 * @param {String} size - small /  medium or large
		 * @param {String} color - light or dark
		 * @param {Boolean} single - show only a single loader at the time or allow for multiple
		 */
		create: (target, inline = false, size = 'large', color, single = false) => {
			if (single) {
				window.loader.destroy();
			}

			let sizeAttr = 'has-loader--' + size;
			let loader = `
				<div class="spinner js-spinner">
					<svg width="18" height="16" viewbox="0 0 18 16" xmlns="http://www.w3.org/2000/svg" class="bounce bounce1">
						<path d="M.035 5.645c-.344 3.11 1.84 8.322 7.776 9.47 3.017.589 7.015-.223 9.002-4.342C23.338-2.817.87-2.397.035 5.645z" fill="#078372" fill-rule="nonzero">
						</path>
					</svg>

					<svg width="18" height="17" viewbox="0 0 18 16" xmlns="http://www.w3.org/2000/svg" class="bounce bounce2">
						<path d="M15.643 2.777A8.172 8.172 0 0 0 12.707.703C7.61-1.48 1.765 1.736.333 6.025c-.035.105-.067.21-.096.316-.561 2.033-.135 4.253 1.372 6.066 1.802 2.168 4.765 3.471 7.601 3.613 3.924.196 7.457-1.079 8.504-4.38.79-2.49-.105-6.65-2.071-8.863z" fill="#02A5E8" fill-rule="nonzero">
						</path>
					</svg>
					<svg width="18" height="18" viewbox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="bounce bounce3">
						<path d="M10.215.437C5.117.437-2.205 5.263.634 11.088c2.839 5.825 12.92 8.488 15.732 2.996C19.112 8.718 19.204.437 10.215.437z" fill="#FF9B35" fill-rule="nonzero">
						</path>
					</svg>
				</div>
			`;

			if (inline) {
				target.classList.add('js-spinner-holder', 'has-loader', sizeAttr);
				target.insertAdjacentHTML('beforeend', loader);
			}
			else {
				target.parentNode.classList.add('js-spinner-holder', 'has-loader', sizeAttr);
				target.insertAdjacentHTML('afterend', loader);
			}
		},
		destroy: () => {
			const loaderElement = document.querySelector('.js-spinner');

			if (loaderElement) {
				loaderElement.classList.remove('js-spinner-holder');
				loaderElement.remove();
			}
		}
	}
})();
